import React, { useCallback, useEffect } from 'react';
import { App, Form } from 'antd';
import { ExclamationCircleFilled, CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/store';
import { PRIMARY_DARK } from '../../constants/constants';
import { simulateVariableTextBox } from '../../utils/boxes';
import FormCustomTextInfos from '../VariableHandler/FormCreator/FormCustomTextInfos';
import ButtonCommon from '../common/ButtonCommon';
import VariableLineStyleControl from './VariableLineStyleControl';

// Accès rapide (depuis un clic sur la variable dans le document) aux mêmes
// champs Nom/Groupe lié/Remarques/Suppression que le formulaire plein écran
// (FormCustomTextInfos), pour éviter l'aller-retour vers ce dernier.
const VariableQuickEditPanel = ({ variableId }) => {
  const { t } = useTranslation();
  const { modal: modalApi } = App.useApp();
  const variable = useStore((state) => state.variables[variableId]);
  const deleteVariableInDocument = useStore((state) => state.deleteVariableInDocument);
  const handleBoxVariableSelectedId = useStore((state) => state.handleBoxVariableSelectedId);
  const [form] = Form.useForm();

  const close = useCallback(() => handleBoxVariableSelectedId(), [handleBoxVariableSelectedId]);

  useEffect(() => {
    if (variable?.notUsed) close();
  }, [variable, close]);

  const validateFormAndRetrieveValues = useCallback(async () => {
    await form.validateFields();
    return form.getFieldsValue();
  }, [form]);

  if (!variable) return null;

  const box = simulateVariableTextBox([variableId, variable]);

  return (
    <div style={{
      border: '1px solid rgba(11, 34, 57, 0.3)',
      borderRadius: 8,
      padding: '8px 12px 12px',
      margin: '0 16px 16px',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
        <span style={{ color: PRIMARY_DARK, fontWeight: 'bold' }}>{t('quick-edit-variable')}</span>
        <CloseOutlined onClick={close} style={{ color: PRIMARY_DARK, cursor: 'pointer' }} />
      </div>
      <Form form={form} key={variableId} className='variable-editor__form' layout='vertical' validateMessages={{ required: 'Champ obligatoire.' }}>
        <FormCustomTextInfos box={box} form={form} validateFormAndRetrieveValues={validateFormAndRetrieveValues} />
      </Form>
      {/* Se monte seul quand l'occurrence cliquée porte une valeur multi-lignes. */}
      <VariableLineStyleControl />
      <ButtonCommon
        type='delete'
        style={{ marginTop: 8 }}
        onClick={() => {
          modalApi.confirm({
            title: t('delete-custom-variable-text-modal', { name: box.name }),
            icon: <ExclamationCircleFilled />,
            okText: t('delete'),
            okType: 'danger',
            cancelText: t('cancel'),
            onOk() {
              deleteVariableInDocument(box.id);
              return false;
            },
            onCancel() {
              return false;
            },
          });
        }}
      >
        {t('delete-custom-variable-text')}
      </ButtonCommon>
    </div>
  );
};

export default VariableQuickEditPanel;
